'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useQuery } from '@tanstack/react-query';
import type { APIResponse } from '@/types/api';
import type { AppLocale } from '@/types/general';
async function fetchCSRNotFoundData(locale: AppLocale) {
  const response = await fetch(`/api/error-data/${locale}`);
  if (response.ok) {
    const data = await response.json();
    return data as APIResponse<Data.ContentType<'api::not-found.not-found'>>;
  }
  return null;
}
const useNotFoundData = t0 => {
  const $ = _c(2);
  const {
    locale
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = {
      queryKey: ["not-found", locale],
      queryFn: () => fetchCSRNotFoundData(locale)
    };
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useQuery(t1);
};
export default useNotFoundData;